import { createReducer, on } from '@ngrx/store';
import { DEFAULT_SUBMISSION_TYPE_STATE } from '../constants';
import { CONFIGURATION_SUBMISSION_TYPE_ACTIONS } from '../actions';
import { SubmissionTypeState } from '../types';

export const SUBMISSION_TYPES_REDUCER = createReducer<SubmissionTypeState>(
  DEFAULT_SUBMISSION_TYPE_STATE,
  on(
    CONFIGURATION_SUBMISSION_TYPE_ACTIONS.onLoadsubmissionListSuccess,
    (state, { submissions }) => ({
      ...state,
      error: null,
      loading: false,
      submissions: {
        ...state.submissions,
        data: submissions.data,
        total: submissions.total,
      },
    }),
  ),

  on(
    CONFIGURATION_SUBMISSION_TYPE_ACTIONS.onLoadDocumentTypesForSubmissionSuccess,
    (state, { documentTypes }) => ({
      ...state,
      submissions: {
        ...state.submissions,
        documentTypes: documentTypes,
      },
    }),
  ),

  on(
    CONFIGURATION_SUBMISSION_TYPE_ACTIONS.onLoadsubmissionListFailure,
    (state, { error }) => ({
      ...state,
      error: error.message || 'Something went wrong',
      loading: false,
      submissions: DEFAULT_SUBMISSION_TYPE_STATE.submissions,
      submissionsTableData: DEFAULT_SUBMISSION_TYPE_STATE.submissionsTableData,
    }),
  ),

  on(
    CONFIGURATION_SUBMISSION_TYPE_ACTIONS.setsubmissionTableData,
    (state, { tableData }) => ({
      ...state,
      submissionsTableData: tableData,
    }),
  ),

  on(
    CONFIGURATION_SUBMISSION_TYPE_ACTIONS.onFetchSubmissionDocumentTypeSuccess,
    (state, { submissionDocument }) => ({
      ...state,
      submissionDocument: submissionDocument,
    }),
  ),
);
